import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import styles from "styles/shared/LoadingStyle";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import * as actions from "redux/actions";
import { Trans } from "adapters/i18n";

export class LoadingSalvando extends Component {
  fecharCarregando = () => {
    this.props.exibirCarregandoSalvando(false);
  };

  render() {
    const { classes, loading, balanco } = this.props;
    return (
      <div
        className={classes.backdrop}
        style={{
          display: loading.ExibirCarregandoSalvando ? "inherit" : "none",
        }}
      >
        <Paper
          className={classes.corpoCarregando}
          elevation={1}
          style={{ borderRadius: 16 }}
        >
          <IconButton
            color="primary"
            aria-label="Add"
            onClick={() => this.fecharCarregando()}
            className={classes.botaoFechar}
          >
            <ClearIcon />
          </IconButton>
          <img
            id="logoFarmTellAppBar"
            src="/images/logo-farmtell-views-color-2.png"
            alt="logo farmtell views"
            className={classes.logo}
          />
          {loading.valorBarraProgresso === 100 ? (
            <React.Fragment>
              {loading.sucesso ? (
                <div>
                  <div className={classes.iconeSucesso}>
                    <img
                      className={classes.imgParabens}
                      src="../images/parabens.svg"
                      alt="loading"
                    />
                  </div>
                  <Typography
                    variant="h6"
                    component="h6"
                    className={classes.corpoFormulario}
                  >
                    <Trans i18nKey="common:status.congratulations" />
                  </Typography>
                  <Typography
                    variant="p"
                    component="p"
                    className={classes.mensagem}
                  >
                    <Trans i18nKey="locales:farm-registration.success-message" />
                  </Typography>
                </div>
              ) : (
                <div>
                  <div className={classes.iconeSucesso}>
                    <img
                      className={classes.imgParabens}
                      src="../images/erro.svg"
                      alt="loading"
                    />
                  </div>
                  <Typography
                    variant="h6"
                    component="h6"
                    className={classes.corpoFormulario}
                  >
                    <Trans i18nKey="errors:general.something-unexpected" />
                  </Typography>
                  <Typography
                    variant="p"
                    component="p"
                    className={classes.mensagem}
                  >
                    <Trans i18nKey="locales:farm-registration.error-message" />
                  </Typography>
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography variant="h6" component="h6">
                <Trans
                  i18nKey={
                    balanco
                      ? "common:status.registering"
                      : "common:status.loading"
                  }
                />
              </Typography>
              <Typography component="p">{loading.textoCarregando}</Typography>
            </React.Fragment>
          )}
        </Paper>
      </div>
    );
  }
}
LoadingSalvando.propTypes = {
  loading: PropTypes.object.isRequired,
};
export default connect(null, actions)(withStyles(styles)(LoadingSalvando));
